import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  signal,
} from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "vw-expand",
  templateUrl: "./expand.component.html",
  imports: [],
})
export class ExpandComponent {
  readonly isOpen = signal(false);

  toggleOpen(): void {
    this.isOpen.update((v) => !v);
  }

  @HostListener("document:keyup.escape")
  onKeydownHandler(): void {
    this.close();
  }

  close(): void {
    this.isOpen.set(false);
  }
}
